import { ShareFormView } from 'features/share/features/share-form/components/ShareFormView'
import { useShareForm } from 'features/share/features/share-form/hooks/use-share-form'
import { useShareService } from 'features/share/service'

interface ShareFormProps {
  email: string | null
  projectId: string
  isUserAdmin: boolean
  onSuccess: () => void
}

export const ShareForm = ({
  email,
  projectId,
  isUserAdmin,
  onSuccess,
}: ShareFormProps): JSX.Element => {
  const service = useShareService()
  const { formik } = useShareForm(service, projectId, email, onSuccess)

  return <ShareFormView formik={formik} isUserAdmin={isUserAdmin} />
}
